/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck
import HospitalEditForm from './HospitalEditForm'

export default function HospitalSelectedDetails({selected, setSelected}) {
  return (
    <div>
        {/* {selected?.name}
        {selected?.address}
        {selected?.email} */}
        {!selected ? 
            <div style={{width: '100%', height: '83vh', display:'flex', justifyContent:'center', alignItems:'center'}}>
                <span className=''>Please select a hospital to view/edit.</span> 
            </div>
        :
            <div className='border p-2' style={{width: '100%', height: '83vh', display:'flex'}}>
                <HospitalEditForm 
                    selected={selected}
                    setSelected={setSelected}
                />
            </div>
        }
        
    </div>
  )
}
